import moment from "moment";
import { getCalenderTimeApi } from "../Service/Cousult.service";

export type AnyAvailableSlot = {
  time: string;
  calendar_id: string;
};

export const fetchAnyAvailableTimes = async (
  hosts: Array<{ calendar_id?: string; acuity_appointment_type_id?: string }> | undefined,
  appointmentTypeId: string | undefined,
  selectedDate: Date | string
): Promise<AnyAvailableSlot[]> => {
  const date = moment(selectedDate).format("YYYY-MM-DD");
  const byTime = new Map<string, string>();

  await Promise.all(
    (hosts || []).map(async (host) => {
      if (!host?.calendar_id) {
        return;
      }

      const res: any = await getCalenderTimeApi({
        acuity_calendar_id: host.calendar_id,
        acuity_appointment_type_id: appointmentTypeId || host.acuity_appointment_type_id,
        date,
      });

      if (!res?.data?.success || !Array.isArray(res?.data?.data)) {
        return;
      }

      res.data.data.forEach((slot: { time?: string }) => {
        if (slot?.time && !byTime.has(slot.time)) {
          byTime.set(slot.time, String(host.calendar_id));
        }
      });
    })
  );

  return Array.from(byTime.entries())
    .map(([time, calendar_id]) => ({ time, calendar_id }))
    .sort((a, b) => a.time.localeCompare(b.time));
};
